import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-search",
  "use": "icon-soc-l1-mall-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-search\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M448 192a256 256 0 1 1 0 512 256 256 0 0 1 0-512zm0 96a160 160 0 1 0 0 320 160 160 0 0 0 0-320z\" />\r\n  <path d=\"M640 640l192 192-64 64-192-192 64-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-search.svg
// module id = CSpq
// module chunks = 491